import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef, useRef, useImperativeHandle, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Languages, dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, MenuUpSVGpath, MenuDownSVGpath } from '@skatteetaten/ds-icons';
import { TopBannerButton } from '../TopBannerButton/index.esm.js';
import { TopBannerLangPickerButton } from '../TopBannerLangPickerButton/index.esm.js';
import './styles.css';


var _style, _rect, _g;
var _excluded$2 = [
    "title",
    "titleId"
];
function _extends$2() {
    return _extends$2 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends$2.apply(null, arguments);
}
function _objectWithoutProperties$2(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose$2(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose$2(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var SvgEnFlag = function SvgEnFlag(_ref, ref) {
    var title = _ref.title, titleId = _ref.titleId, props = _objectWithoutProperties$2(_ref, _excluded$2);
    return /*#__PURE__*/ React.createElement("svg", _extends$2({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 1000 600",
        style: {
            enableBackground: "new 0 0 1000 600"
        },
        xmlSpace: "preserve",
        focusable: "false",
        "aria-hidden": "true",
        ref: ref,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ React.createElement("title", {
        id: titleId
    }, title) : null, _style || (_style = /*#__PURE__*/ React.createElement("style", {
        type: "text/css"
    }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#012169;}\n\t.st2{fill:#C8102E;}\n")), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        className: "st0",
        width: 1000,
        height: 600
    })), _g || (_g = /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "165.8,200 0,200 0,117.1  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "165.8,400 0,482.9 0,400  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "600,600 965.8,600 600,417.1  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "34.2,600 400,600 400,417.1  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "400,0 34.2,0 400,182.9  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "1000,400 1000,482.9 834.2,400  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "965.8,0 600,0 600,182.9  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st1",
        points: "1000,117.1 1000,200 834.2,200  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st2",
        points: "1000,5.3 1000,50 700,200 610.6,200  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st2",
        points: "389.4,200 210.6,200 0,94.7 0,5.3  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st2",
        points: "389.4,400 0,594.7 0,505.3 210.6,400  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st2",
        points: "1000,505.3 1000,594.7 610.6,400 789.4,400  "
    }), /*#__PURE__*/ React.createElement("polygon", {
        className: "st2",
        points: "1000,240 1000,360 560,360 560,600 440,600 440,360 0,360 0,240 440,240 440,0 560,0 560,240  "
    }))));
};
var ForwardRef$2 = /*#__PURE__*/ forwardRef(SvgEnFlag);

var _excluded$1 = [
    "title",
    "titleId"
];
function _extends$1() {
    return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends$1.apply(null, arguments);
}
function _objectWithoutProperties$1(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose$1(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var SvgNoFlag = function SvgNoFlag(_ref, ref) {
    var title = _ref.title, titleId = _ref.titleId, props = _objectWithoutProperties$1(_ref, _excluded$1);
    return /*#__PURE__*/ React.createElement("svg", _extends$1({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1100 800",
        focusable: "false",
        "aria-hidden": "true",
        ref: ref,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ React.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ React.createElement("polygon", {
        points: "500 0 450 0 450 350 1100 350 1100 300 500 300 500 0",
        style: {
            fill: "#fff"
        }
    }), /*#__PURE__*/ React.createElement("polygon", {
        points: "450 450 450 800 500 800 500 500 1100 500 1100 450 450 450",
        style: {
            fill: "#fff"
        }
    }), /*#__PURE__*/ React.createElement("polygon", {
        points: "350 450 0 450 0 500 300 500 300 800 350 800 350 450",
        style: {
            fill: "#fff"
        }
    }), /*#__PURE__*/ React.createElement("polygon", {
        points: "350 350 350 0 300 0 300 300 0 300 0 350 350 350",
        style: {
            fill: "#fff"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 300,
        height: 300,
        style: {
            fill: "#ef2b2d"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        x: 500,
        width: 600,
        height: 300,
        style: {
            fill: "#ef2b2d"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        y: 500,
        width: 300,
        height: 300,
        style: {
            fill: "#ef2b2d"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        x: 500,
        y: 500,
        width: 600,
        height: 300,
        style: {
            fill: "#ef2b2d"
        }
    }), /*#__PURE__*/ React.createElement("polygon", {
        points: "450 350 450 0 350 0 350 350 0 350 0 450 350 450 350 800 450 800 450 450 1100 450 1100 350 450 350",
        style: {
            fill: "#002868"
        }
    }));
};
var ForwardRef$1 = /*#__PURE__*/ forwardRef(SvgNoFlag);

var _excluded = [
    "title",
    "titleId"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var SvgSaFlag = function SvgSaFlag(_ref, ref) {
    var title = _ref.title, titleId = _ref.titleId, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 808 600",
        focusable: "false",
        "aria-hidden": "true",
        ref: ref,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ React.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ React.createElement("path", {
        d: "m370,0v116.34c78.64,24.02,136,97.27,136,183.66s-57.36,159.64-136,183.66v116.34h438V0h-438Z",
        style: {
            fill: "#0035ad"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m474,300c0-68.53-43.31-127.13-104-149.88v299.76c60.69-22.75,104-81.35,104-149.88Z",
        style: {
            fill: "#0035ad"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m370,116.34V0h-56v108c19.47,0,38.28,2.92,56,8.34Z",
        style: {
            fill: "#ffce00"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m314,492v108h56v-116.34c-17.72,5.42-36.53,8.34-56,8.34Z",
        style: {
            fill: "#ffce00"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m370,449.88V150.12c-17.44-6.54-36.31-10.12-56-10.12v320c19.69,0,38.56-3.58,56-10.12Z",
        style: {
            fill: "#ffce00"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m258,449.92c17.43,6.51,36.3,10.08,56,10.08V140c-19.7,0-38.57,3.57-56,10.08v299.83Z",
        style: {
            fill: "#007229"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m314,108V0h-56v116.31c17.72-5.39,36.52-8.31,56-8.31Z",
        style: {
            fill: "#007229"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m258,483.69v116.31h56v-108c-19.48,0-38.28-2.91-56-8.31Z",
        style: {
            fill: "#007229"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m122,300c0-86.56,57.28-159.73,136-183.69V0H0v600h258v-116.31c-78.72-23.97-136-97.14-136-183.69Z",
        style: {
            fill: "#dc241f"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m154,300c0,68.66,43.26,127.22,104,149.92V150.08c-60.74,22.7-104,81.25-104,149.92Z",
        style: {
            fill: "#dc241f"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m258,449.92c-60.74-22.7-104-81.25-104-149.92s43.26-127.22,104-149.92c17.43-6.51,36.3-10.08,56-10.08v-32c-19.48,0-38.28,2.91-56,8.31-78.72,23.97-136,97.14-136,183.69s57.28,159.73,136,183.69c17.72,5.39,36.52,8.31,56,8.31v-32c-19.7,0-38.57-3.57-56-10.08Z",
        style: {
            fill: "#0035ad"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m314,140c19.69,0,38.56,3.58,56,10.12,60.69,22.75,104,81.35,104,149.88s-43.31,127.13-104,149.88c-17.44,6.54-36.31,10.12-56,10.12v32c19.47,0,38.28-2.92,56-8.34,78.64-24.02,136-97.27,136-183.66s-57.36-159.64-136-183.66c-17.72-5.42-36.53-8.34-56-8.34v32Z",
        style: {
            fill: "#dc241f"
        }
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(SvgSaFlag);

const getTopBannerLangPickerShowSamiDefault = ()=>true;
const getTopBannerLangPickerLocaleDefault = ()=>Languages.Bokmal;

const convertLocaleToLang = (locale)=>{
    return locale.substring(0, locale.indexOf('_'));
};
const isLanguages = (value)=>{
    return Object.values(Languages).includes(value);
};
const getCurrentLanguages = (includeSami, additionalLanguages = [])=>{
    const defaultLanguages = {
        nb: {
            lang: 'nb',
            displayName: 'Bokmål'
        },
        nn: {
            lang: 'nn',
            displayName: 'Nynorsk'
        },
        en: {
            lang: 'en',
            displayName: 'English'
        }
    };
    const se = {
        se: {
            lang: 'se',
            displayName: 'Sámegiella'
        }
    };
    const additionalLanguagesAsObject = additionalLanguages?.reduce((acc, curr)=>{
        acc[curr.lang] = curr;
        return acc;
    }, {});
    return includeSami ? {
        ...defaultLanguages,
        ...se,
        ...additionalLanguagesAsObject
    } : {
        ...defaultLanguages,
        ...additionalLanguagesAsObject
    };
};

var styles = {
    "container": "TopBannerLangPicker-module_container__MLnml",
    "overlay": "TopBannerLangPicker-module_overlay__M4c6u",
    "menuButton": "TopBannerLangPicker-module_menuButton__aFB56",
    "iconWrapper": "TopBannerLangPicker-module_iconWrapper__taomt",
    "flagIcon": "TopBannerLangPicker-module_flagIcon__--L7w",
    "flagIconSvg": "TopBannerLangPicker-module_flagIconSvg__ofXcL",
    "arrowMobile": "TopBannerLangPicker-module_arrowMobile__9JAp5",
    "arrowDesktop": "TopBannerLangPicker-module_arrowDesktop__yqT9F",
    "menu": "TopBannerLangPicker-module_menu__OImjK",
    "menuArrow": "TopBannerLangPicker-module_menuArrow__KXQrb",
    "list": "TopBannerLangPicker-module_list__t1KDB",
    "listItem": "TopBannerLangPicker-module_listItem__oVbqw",
    "srOnly": "TopBannerLangPicker-module_srOnly__CjC1W"
};

const getFlag = (lang, additionalLanguages = [])=>{
    for (const language of additionalLanguages){
        if (language.lang === lang) {
            return language.flag({
                className: styles.flagIconSvg
            });
        }
    }
    switch(lang){
        case 'en':
            return /*#__PURE__*/ jsx(ForwardRef$2, {
                className: styles.flagIconSvg
            });
        case 'se':
            return /*#__PURE__*/ jsx(ForwardRef, {
                className: styles.flagIconSvg
            });
        case 'nb':
        case 'nn':
        default:
            return /*#__PURE__*/ jsx(ForwardRef$1, {
                className: styles.flagIconSvg
            });
    }
};
const TopBannerLangPicker = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, defaultLocale = getTopBannerLangPickerLocaleDefault(), showSami = getTopBannerLangPickerShowSamiDefault(), additionalLanguages, onLanguageClick, openMenu, setOpenMenu, menuButtonRef }, ref)=>{
    const { t } = useTranslation('ds_layout', {
        i18n: dsI18n
    });
    const menuRef = useRef(null);
    const menuButtonRefInternal = useRef(null);
    useImperativeHandle(menuButtonRef, ()=>menuButtonRefInternal?.current);
    const [selectedLang, setSelectedLang] = useState(isLanguages(defaultLocale) ? convertLocaleToLang(defaultLocale) : defaultLocale);
    useEffect(()=>{
        document.documentElement.lang = selectedLang;
    }, [
        selectedLang
    ]);
    const languages = useMemo(()=>getCurrentLanguages(showSami, additionalLanguages), [
        showSami,
        additionalLanguages
    ]);
    const [currentFocus, setCurrentFocus] = useState(-1);
    const isMenuOpen = openMenu === 'Lang';
    useEffect(()=>{
        if (!isMenuOpen) {
            setCurrentFocus(-1);
            return;
        }
        const handleOutsideMenuEvent = (event)=>{
            const node = event.composedPath()[0];
            if (!menuButtonRefInternal?.current?.contains(node) && !menuRef.current?.contains(node)) {
                setOpenMenu('None');
                event.type === 'click' && menuButtonRefInternal?.current?.focus();
            }
        };
        const handleKeyDown = (e)=>{
            const languageLength = Object.keys(languages).length;
            if (e.key === 'ArrowUp' || e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                setCurrentFocus((currentFocus)=>currentFocus === 0 ? languageLength - 1 : currentFocus - 1);
            } else if (e.key === 'ArrowDown' || e.key === 'Tab') {
                e.preventDefault();
                setCurrentFocus((currentFocus)=>currentFocus === languageLength - 1 ? 0 : currentFocus + 1);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('focusin', handleOutsideMenuEvent);
        document.addEventListener('click', handleOutsideMenuEvent);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('click', handleOutsideMenuEvent);
            document.removeEventListener('focusin', handleOutsideMenuEvent);
        };
    }, [
        isMenuOpen,
        setOpenMenu,
        languages
    ]);
    const handleLanguageClick = (e)=>{
        setSelectedLang(e.currentTarget.lang);
        setOpenMenu('None');
        menuButtonRefInternal?.current?.focus();
        onLanguageClick?.(e);
    };
    const handleMenuClick = ()=>{
        setOpenMenu(isMenuOpen ? 'None' : 'Lang');
    };
    return /*#__PURE__*/ jsxs("div", {
        ref: ref,
        id: id,
        className: `${styles.container} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: isMenuOpen ? styles.overlay : ''
            }),
            /*#__PURE__*/ jsxs(TopBannerButton, {
                ref: menuButtonRefInternal,
                lang: selectedLang,
                className: styles.menuButton,
                ariaExpanded: isMenuOpen,
                onClick: handleMenuClick,
                onKeyDown: (e)=>{
                    if (e.shiftKey && e.key === 'Tab') {
                        /* Stopper propagering slik at eventet ikke fanges av eventListener på document og vi
                får tilbake standard oppførsel på tab og shift-tab. */ e.stopPropagation();
                    }
                },
                children: [
                    /*#__PURE__*/ jsxs("span", {
                        className: styles.iconWrapper,
                        children: [
                            /*#__PURE__*/ jsx("span", {
                                className: styles.flagIcon,
                                children: getFlag(selectedLang, additionalLanguages)
                            }),
                            /*#__PURE__*/ jsx(Icon, {
                                svgPath: isMenuOpen ? MenuUpSVGpath : MenuDownSVGpath,
                                className: styles.arrowMobile
                            })
                        ]
                    }),
                    languages[selectedLang]?.displayName ?? languages['nb'].displayName,
                    /*#__PURE__*/ jsxs("span", {
                        className: styles.srOnly,
                        children: [
                            " ",
                            t('topbannerbutton.Menu')
                        ]
                    }),
                    /*#__PURE__*/ jsx(Icon, {
                        svgPath: isMenuOpen ? MenuUpSVGpath : MenuDownSVGpath,
                        className: styles.arrowDesktop
                    })
                ]
            }),
            /*#__PURE__*/ jsx("div", {
                className: styles.menuArrow
            }),
            isMenuOpen && /*#__PURE__*/ jsx("div", {
                ref: menuRef,
                className: styles.menu,
                children: /*#__PURE__*/ jsx("ul", {
                    className: styles.list,
                    children: Object.values(languages).map((language, index)=>{
                        return /*#__PURE__*/ jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ jsx(TopBannerLangPicker.Button, {
                                lang: language.lang,
                                ariaCurrent: language.lang === selectedLang,
                                flagIcon: getFlag(language.lang, additionalLanguages),
                                focus: index === currentFocus,
                                onClick: handleLanguageClick,
                                onKeyDown: (e)=>{
                                    /* Hvis vi er på første eller siste element stopper vi propagering slik at
                           eventet ikke fanges av eventListener på document og vi får tilbake
                           standard oppførsel på tab og shift-tab. */ if (index === Object.keys(languages).length - 1 && e.key === 'Tab' || index === 0 && e.shiftKey && e.key === 'Tab') {
                                        e.stopPropagation();
                                    }
                                },
                                children: language.displayName
                            })
                        }, `${language.lang}`);
                    })
                })
            })
        ]
    });
});
TopBannerLangPicker.displayName = 'TopBannerLangPicker';
TopBannerLangPicker.Button = TopBannerLangPickerButton;

export { TopBannerLangPicker };
